import { FC } from 'react';
import classnames from 'classnames';
import { LayOutPageFooterProps, LayOutPageItemEnum } from './interface';

const LayOutPageFooter: FC<LayOutPageFooterProps> = props => {
  const { children, className, ...restProps } = props;
  const classes = classnames('yb-layout-page-footer', className);
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

LayOutPageFooter.displayName = LayOutPageItemEnum.Footer;

export default LayOutPageFooter;
